import React from "react";
import { Field } from "formik";

import { FIELD_FILES } from "../formSettings";

import { FormLayout } from "../components/FormLayout";
import { InputFile } from "../components/InputFile";

import { ImportType } from "../types";

import { fetchFileList } from "./fetchFileList";

export const FormComponent: React.FC = () => (
  <FormLayout importType={ImportType.googleDrive}>
    <Field
      name={FIELD_FILES}
      component={InputFile}
      importType={ImportType.googleDrive}
      fetchFileList={fetchFileList}
    />
  </FormLayout>
);
